/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

export default $ => css`
  .table-wrapper {
    &.table-fixed-header {
      overflow-y: auto;

      > .table {
        border-collapse: separate;
      }
    }

    &.table-fixed-columns {
      overflow-x: auto;

      > .table {
        border-collapse: separate;
      }
    }
  }

  th.wrap-cell,
  td.wrap-cell {
    white-space: pre-wrap !important;
  }

  th.no-wrap-cell,
  td.no-wrap-cell {
    white-space: nowrap;
  }

  .object-table-cell {
    // white-space: pre-wrap;
    max-width: 50% !important;

    label.control-label {
      white-space: pre-wrap;
    }

    & > .rjsf-field > .form-group {
      margin: 0;
    }
  }

  .object-table-scroll-wrapper {
    position: relative;
    overscroll-behavior-inline: contain;
    /* max-width: 100% ensures the table never extends past its container.
       overflow-x: auto shows a scrollbar only when content is wider than the wrapper,
       which is the correct behaviour for both sticky-columns and horizontal-scroll modes.
       overflow-y is handled per-instance via inline style when stickyHeaders is active. */
    max-width: 100%;
    overflow-x: auto;
  }

  .object-table-col-resize-handle {
    position: absolute;
    top: 0;
    right: -3px;
    width: 7px;
    height: 100%;
    cursor: col-resize;
    z-index: 20;
    touch-action: none;

    &:hover,
    &:active {
      background: rgba(80, 130, 255, 0.35);
    }
  }

  .object-table-scroll-indicator {
    position: absolute;
    z-index: 15;
    pointer-events: none;
    height: 100%;
    right: 0;
    top: 0;
    bottom: 0;
  }

  .rjsf-object-table {
    font-size: 13px !important;

    td,
    th {
      border-width: 0;

      &:has(+ td),
      &:has(+ th) {
        border-right-width: 1px;
      }
    }

    thead {
      tr {
        outline: 1px solid rgb(222, 226, 230);
      }
    }

    tr {
      td,
      th {
        border-top-width: 1px;
      }
    }

    tr td:last-of-type {
      border-right-width: 1px;
    }

    border-radius: 8px !important;
    & tr:first-of-type td:first-of-type {
      border-top-left-radius: 8px !important;
    }

    .control-label {
      font-size: 13px;
    }

    .schema-field:has(+ .schema-field) .control-label {
      margin-bottom: 8px !important;
    }

    .schema-field:has(> .control-label):has(> div.mb-3 > div:empty) .control-label {
      margin-bottom: 0;
    }

    .schema-field:has(+ .schema-field.control-label) {
      margin-bottom: 12px;
    }

    .schema-field > .mb-3 {
      margin-bottom: 0 !important;
    }

    .rjsf-field-string {
      p {
        margin-bottom: 0;

        &:has(+ p) {
          margin-bottom: 8px;
        }
      }
    }

    h1,
    h2,
    h3 {
      font-size: 16px;
      margin-bottom: 0;
    }

    h4,
    h5,
    h6 {
      font-size: 15px;
      margin-bottom: 0;
    }
  }
`;
